import React from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import cn from 'classnames';
import { IconButton, Snackbar as MuiSnackbar, SnackbarContent } from '@material-ui/core';
import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
  Close as CloseIcon,
} from '@material-ui/icons';
import useStyles from './Snackbar.styles';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const Snackbar = props => {
  const { open, message, variant, showCloseButton, onClose, className, ...other } = props;
  const classes = useStyles();
  const Icon = variantIcon[variant];

  const renderMessage = () => {
    return (
      <span id="message-id" className={classes.message}>
        {variant !== 'default' && (
          <Icon
            className={cn(classes.icon, {
              [classes.iconVariant]: true,
            })}
          />
        )}
        {message}
      </span>
    );
  };

  return (
    <MuiSnackbar open={open} onClose={onClose} className={classes.root} {...other}>
      <SnackbarContent
        className={cn(
          classes.content,
          {
            [classes[variant]]: true,
          },
          className,
        )}
        aria-describedby="message-id"
        message={renderMessage()}
        action={[
          showCloseButton && (
            <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
              <CloseIcon className={classes.icon} />
            </IconButton>
          ),
        ]}
      />
    </MuiSnackbar>
  );
};

Snackbar.propTypes = {
  open: Type.bool,
  anchorOrigin: Type.shape({
    horizontal: Type.oneOf(['left', 'center', 'right']).isRequired,
    vertical: Type.oneOf(['top', 'bottom']),
  }),
  message: Type.node,
  autoHideDuration: Type.number,
  className: Type.string,
  variant: Type.oneOf(['default', 'error', 'info', 'success', 'warning']),
  showCloseButton: Type.bool,
  onClose: Type.func,
};

Snackbar.defaultProps = {
  open: false,
  message: '',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  className: '',
  autoHideDuration: 4000,
  showCloseButton: false,
  variant: 'default',
  onClose: noop,
};

export default Snackbar;
